import { twMerge } from 'tailwind-merge';

import { CurrencyIcon } from '@/entities/currency';
import { useVabsAccountsStore } from '@/entities/currency-account';

import { getValueWithCurrency } from '@/shared/lib';
import { Typography } from '@/shared/ui';

export const AccountView: React.FC<{ ticker?: string; className?: string }> = ({
  ticker,
  className,
}) => {
  const accounts = useVabsAccountsStore((state) => state.accounts);
  const account = accounts.find((i) => i.code === ticker);

  return (
    account && (
      <div
        className={twMerge(
          'flex items-center justify-between rounded-[20px] bg-base-300 px-5 py-[18px]',
          className,
        )}
      >
        <div className="flex items-center gap-4">
          <CurrencyIcon ticker={account.code} />
          <div className="flex flex-col gap-1">
            <Typography>{account.code} Account</Typography>
            <Typography variant="13-r" color="text-base-100">
              {`${getValueWithCurrency(String(account.value), account.symbol)} available`}
            </Typography>
          </div>
        </div>
      </div>
    )
  );
};
